import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  variant?: 'default' | 'featured';
}

export default function ComicCard({ comic, variant = 'default' }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg ${
        variant === 'featured' ? 'aspect-[3/4]' : 'aspect-[3/4]'
      }`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 韩国漫画在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        {comic.status === '连载中' && (
          <div className="absolute top-2 left-2 bg-primary-500 text-white dark:text-foreground-950 text-xs font-medium px-2 py-0.5 rounded-md">
            连载中
          </div>
        )}
        {comic.status === '已完结' && (
          <div className="absolute top-2 left-2 bg-accent-500 text-white dark:text-foreground-950 text-xs font-medium px-2 py-0.5 rounded-md">
            已完结
          </div>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-1 mb-1">
            <i className="ri-star-fill text-yellow-400 text-xs w-3 h-3 flex items-center justify-center"></i>
            <span className="text-white text-xs">{comic.rating}</span>
          </div>
          <h3 className="text-white text-sm font-semibold truncate">{comic.title}</h3>
        </div>
      </div>

      <div className="mt-2 px-0.5">
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-xs text-foreground-400">
            {comic.views > 1000000
              ? `${(comic.views / 1000000).toFixed(1)}M`
              : `${(comic.views / 10000).toFixed(0)}万`} 阅读
          </span>
        </div>
      </div>
    </Link>
  );
}